import { Injectable } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";

import { first, mergeMap } from "rxjs/operators";
import { GisClientService } from "./gis-client.service";

@Injectable()
export class GoogleAuthService {
  onInitialized = new ReplaySubject<boolean>(1);

  // TODO: put this somewhere else?
  private clientId =
    "867912217923-7trf7nsgu97tgfo85gl1ivop31jb4j40.apps.googleusercontent.com";

  credentials$ = new Subject<string>();

  constructor(private gisClientService: GisClientService) {
    this.init();
  }

  private init(): void {
    this.gisClientService.get().subscribe((client) => {
      client.id.initialize({
        client_id: this.clientId,
        callback: ({ credential }) => {
          this.credentials$.next(credential);
        }
      });
      this.onInitialized.next(true);
    });
  }

  renderButton(parentEl: HTMLElement, width?: string): void {
    this.onInitialized
      .pipe(
        first(),
        mergeMap(() => this.gisClientService.get())
      )
      .subscribe((client) =>
        client.id.renderButton(parentEl, {
          type: "standard",
          width
        })
      );
  }
}
